import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Link from '../../shared/Link/Link';
import Button from '../../shared/Button/Button';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import fetch from 'isomorphic-fetch';

import AsyncSelect from '../../shared/AsyncSelect/AsyncSelect';
import TextField from '../../shared/FormFields/TextField';
import SelectField from '../../shared/FormFields/SelectField';
import RadioContainer from '../../shared/FormFields/RadioContainer';
import CheckboxContainer from '../../shared/FormFields/CheckboxContainer';
import { createUser } from '../../../redux/modules/user';
import { loadCities } from '../../../redux/modules/cities';
import { loadCountries } from '../../../redux/modules/countries';
import api from '../../../api';
import FacebookLogin from 'react-facebook-login';

import { primary_s20_l87 } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import {
  codiceFiscaleValido,
  cognomeCoerente,
  nomeCoerente,
} from '../../shared/lib/codiceFiscale';
import { pIvaCoerente } from '../../shared/lib/pIva';

import { MdCheck } from 'react-icons/md';
import './Registrazione.scss';
import IubendaCookieSolution from '../../../utils/iubenda';

class Registrazione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formSubmitted: false,
    };
  }

  componentDidMount() {
    this.props.loadCountries();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.country !== this.props.country) {
      this.props.change('shipping.city', '');
    }
    // if (
    //   oldProps.loading !== this.props.loading &&
    //   !this.props.loading &&
    //   !!this.props.authenticated
    // ) {
    //   // USER HAS SUCCESSFULLY SIGNED UP
    //   // NASCONDI FORM > RINGRAZIAMENTO
    //   this.setState({
    //     formSubmitted: true,
    //   });
    // }
  }

  createUserData = async userData => {
    const hasRicetta = this.props.cart
      ? this.props.cart.find(product => !!product.prescription)
      : false;

    const form = this._getForm('form_signup', userData);

    this.props.createUser(
      userData,
      this.props.location.query.isCheckout,
      false,
      !!hasRicetta,
      form
    );
    // // NASCONDI FORM > RINGRAZIAMENTO
    this.setState({
      formSubmitted: true,
    });
  };

  _getForm = (id, obj) => {
    let form;
    try {
      form = window.document.getElementById(id);
      if (!!form) {
        form = (form.outerHTML || '').replace(
          /type="password" class="form-control" value=\"(.*?)\"/g,
          'type="password" class="form-control" value="*******"'
        );
        return form;
      }
    } catch (err) {
      console.error('Errore getting form', err);
    }
    return JSON.stringify(obj);
  };

  ///////////////////////////////////////////////////////////////
  // GESTIONE COMUNI AUTOCOMPLETE

  getCities = (input, callback) => {
    if (!input) {
      if (!!callback) {
        callback(null, {
          options: [],
        });
      }
    }

    this.props.loadCities(input || null, 4).then(action => {
      if (!!callback) {
        callback(null, {
          options:
            !!action.payload && !!action.payload.length
              ? action.payload.map(city => {
                  return {
                    value: `${city.city}|${city.province}`,
                    label: `${city.city} (${city.province})`,
                  };
                })
              : [],
        });
      }
    });
  };

  renderSelectCities = ({ input, name, meta: { touched, error } }) => {
    return (
      <div className={`form-group ${touched && error && 'error'}`}>
        <AsyncSelect
          name={name}
          value={input.value}
          openOnClick={false}
          loadOptions={this.getCities}
          labelKey="label"
          valueKey="value"
          onChange={val => {
            if (val && val.value) {
              input.onChange(val);
            } else {
              input.onChange('');
            }
          }}
          onBlur={() => input.onBlur(input.value)}
          placeholder="Città"
          loadingPlaceholder="Caricamento..."
          clearValueText="Annulla"
          searchPromptText="Digita la città..."
        />
        {touched && error && <div className="error-text">{error}</div>}
      </div>
    );
  };
  ///////////////////////////////////////////////////////////////

  // renderField({ input, label, type, meta: { asyncValidating, touched, error } }) {
  //   return (
  //     <div className={`form-group ${touched && error && 'error'} ${asyncValidating ? 'async-validating' : ''}`}>
  //       <input {...input} placeholder={label} type={type} className="form-control" />
  //       {touched && error && <div className="error-text">{error}</div>}
  //     </div>
  //   )
  // }

  renderPrivacyCheck = ({ input, type, meta: { touched, error } }) => {
    const { privacy } = this.props;
    if (!!privacy && !!privacy.privacyText) {
      return (
        <CheckboxContainer
          className={`privacy-checkbox ${touched && error && 'error'}`}
        >
          <input {...input} id="privacy-checkbox" type={type} />
          <label
            htmlFor="privacy-checkbox"
            dangerouslySetInnerHTML={{ __html: privacy.privacyText }}
          />
          {touched && error && <div className="error-text">{error}</div>}
        </CheckboxContainer>
      );
    }

    return (
      <CheckboxContainer
        className={`privacy-checkbox ${touched && error && 'error'}`}
      >
        <input {...input} id="privacy-checkbox" type={type} />
        <label htmlFor="privacy-checkbox">
          Acconsento all’utilizzo dei dati inseriti secondo le finalità indicate
          dalla{' '}
          <Link to="/pagine/informativa-privacy" target="_blank">
            privacy policy
          </Link>
        </label>
        {touched && error && <div className="error-text">{error}</div>}
      </CheckboxContainer>
    );
  };

  renderMarketingCheck = ({ input, type, meta: { touched, error } }) => {
    const { privacy } = this.props;
    if (!!privacy && !!privacy.marketingText) {
      return (
        <CheckboxContainer
          className={`newsletter-checkbox ${touched && error && 'error'}`}
        >
          <input {...input} id="hasSubscribedToNewsletter" type={type} />
          <label
            htmlFor="hasSubscribedToNewsletter"
            dangerouslySetInnerHTML={{
              __html: privacy.marketingText,
            }}
          />
          {touched && error && <div className="error-text">{error}</div>}
        </CheckboxContainer>
      );
    }

    return (
      <CheckboxContainer className="newsletter-checkbox">
        <input {...input} id="hasSubscribedToNewsletter" type={type} />
        <label htmlFor="hasSubscribedToNewsletter">
          Desidero restare aggiornato sugli sconti e promozioni e acconsento
          all’uso dei miei dati per finalità commerciali
        </label>
      </CheckboxContainer>
    );
  };

  registerFacebook = response => {
    if (!!response && !!response.email && !!response.name) {
      const shipping = {
        name: response.name,
      };
      const names = response.name.split(' ');
      const billing = {
        isCompany: false,
        name: response.name,
        firstname: names[0],
        lastname: names.length > 1 ? names[1] : '',
      };
      const hasAcceptedPrivacyPolicy = true;
      const hasSubscribedToNewsletter = true;
      this.props.createUser(
        {
          name: response.name,
          email: response.email,
          password: null,
          providerId: response.id,
          provider: 'facebook',
          shipping,
          billing,
          hasAcceptedPrivacyPolicy,
          hasSubscribedToNewsletter,
        },
        false,
        true
      );
    }
  };

  render() {
    const {
      primaryColor,
      facebookAppId,
      hasFacebookLogin,
      countries,
      hasSalesAbroad,
      country,
      uiVariantButton,
      createUserError,
    } = this.props;

    const registrazioneStyle = css`
      h3 {
        background-color: ${primary_s20_l87(primaryColor)}!important;
        border-radius: ${uiVariantButton === '1'
          ? '12px'
          : uiVariantButton === '3'
          ? '30px'
          : 0};
      }
    `;

    const RadioInput = ({ input, type, name, id }) => {
      return <input name={name} id={id} type={type} value={input.value} />;
    };

    const { provider } = this.props.location.query;

    return (
      <div className="registrazione" css={registrazioneStyle}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              {this.state.formSubmitted ? (
                <div className="thanks">
                  <div
                    className="check"
                    style={{
                      color: `${primaryColor}`,
                      borderColor: `${primaryColor}`,
                    }}
                  >
                    <MdCheck />
                  </div>
                  <h1>Grazie!</h1>
                  <p>Grazie per esserti registrato. Buoni acquisti!</p>
                  <div className="redirect-btns">
                    <Link to="/">
                      <Button className="btn btn-outline btn-thick">
                        Vai in Home
                      </Button>
                    </Link>
                    <Link to="/prodotti-in-offerta">
                      <Button className="btn btn-outline btn-thick">
                        Vai ai prodotti
                      </Button>
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="registration-form">
                  <h1>Registrati</h1>
                  {!this.props.onlyCompanySignUp && hasFacebookLogin && (
                    <div className="facebook-container">
                      <FacebookLogin
                        appId={facebookAppId}
                        isMobile={false}
                        autoLoad={false}
                        fields="name,email,picture"
                        callback={this.registerFacebook}
                        cssClass="btn signup-facebook-button-class"
                        textButton="Registrati con Facebook"
                        icon="fa-facebook"
                      />
                      {!!createUserError && (
                        <div style={{ fontSize: 13, color: '#f77878' }}>
                          {createUserError}
                        </div>
                      )}
                    </div>
                  )}
                  <p className="subtitle">
                    Inserisci i tuoi dati per poter accedere all'area riservata
                    e completare così i tuoi acquisti.
                  </p>

                  <form
                    id="form_signup"
                    onSubmit={this.props.handleSubmit(this.createUserData)}
                  >
                    <div
                      className="row"
                      style={{
                        justifyContent: this.props.onlyCompanySignUp
                          ? 'center'
                          : 'unset',
                      }}
                    >
                      {!this.props.onlyCompanySignUp ? (
                        <>
                          <div className="col-sm-6">
                            <RadioContainer>
                              <Field
                                name="billing.isCompany"
                                id="isPrivate"
                                component="input"
                                type="radio"
                                value="false"
                              />
                              <label htmlFor="isPrivate">
                                Registrati come privato
                              </label>
                            </RadioContainer>
                          </div>
                          <div className="col-sm-6">
                            <RadioContainer>
                              <Field
                                name="billing.isCompany"
                                id="isCompany"
                                component="input"
                                type="radio"
                                value={
                                  this.props.onlyCompanySignUp
                                    ? 'false'
                                    : 'true'
                                }
                              />
                              <label htmlFor="isCompany">
                                Registrati come azienda
                              </label>
                            </RadioContainer>
                          </div>
                        </>
                      ) : (
                        <div>Registrazione consentita solo alle aziende</div>
                      )}
                    </div>

                    <hr />

                    <h3>Dati account</h3>

                    <Field
                      name="email"
                      component={TextField}
                      type="email"
                      label="Email"
                    />
                    {!provider && (
                      <>
                        <Field
                          name="password"
                          component={TextField}
                          type="password"
                          label="Inserisci una password"
                        />
                        <Field
                          name="confirmPassword"
                          component={TextField}
                          type="password"
                          label="Conferma password"
                        />
                      </>
                    )}

                    <Field
                      name="provider"
                      label="provider"
                      component={TextField}
                      type="text"
                      style={{ height: 0 }}
                    />
                    <Field
                      name="providerId"
                      label="providerId"
                      component={TextField}
                      type="text"
                      style={{ height: 0 }}
                    />
                    {this.props.simpleRegistration ? (
                      <h3>Dati anagrafici</h3>
                    ) : (
                      <h3>Indirizzo di fatturazione</h3>
                    )}

                    {this.props.isCompany === 'true' && (
                      <Field
                        name="billing.company"
                        component={TextField}
                        type="text"
                        label="Ragione sociale"
                      />
                    )}
                    <Field
                      name="billing.firstname"
                      component={TextField}
                      type="text"
                      label="Nome"
                    />
                    <Field
                      name="billing.lastname"
                      component={TextField}
                      type="text"
                      label="Cognome"
                    />
                    {!this.props.simpleRegistration && (
                      <Field
                        name="billing.taxCode"
                        component={TextField}
                        type="text"
                        label="Codice fiscale"
                        normalize={normalizeTaxCode}
                      />
                    )}

                    {this.props.isCompany === 'true' && (
                      <div>
                        <Field
                          name="billing.vatNumber"
                          component={TextField}
                          type="text"
                          label="P.IVA"
                        />
                        <Field
                          name="billing.sdiCode"
                          component={TextField}
                          type="text"
                          label="Codice univoco SDI"
                        />
                        <Field
                          name="billing.pec"
                          component={TextField}
                          type="text"
                          label="Indirizzo PEC"
                        />
                      </div>
                    )}
                    {!this.props.simpleRegistration && (
                      <>
                        <Field
                          name="billing.address1"
                          component={TextField}
                          type="text"
                          label="Indirizzo e Numero Civico"
                        />
                        <Field
                          name="billing.address2"
                          component={TextField}
                          type="text"
                          label="Note indirizzo"
                        />

                        <div className="row">
                          <div className="col-sm-8">
                            <Field
                              name="billing.city"
                              id="billing.city"
                              component={this.renderSelectCities}
                              label="Città"
                            />
                          </div>
                          <div className="col-sm-4">
                            <Field
                              name="billing.zipcode"
                              component={TextField}
                              type="text"
                              label="CAP"
                              normalize={normalizeZipcode}
                            />
                          </div>
                        </div>
                        <Field
                          name="billing.phone"
                          component={TextField}
                          type="text"
                          label="Telefono"
                        />

                        <h3>Indirizzo di spedizione</h3>

                        <CheckboxContainer className="address-checkbox">
                          <Field
                            name="shipping.sameAsBilling"
                            component="input"
                            type="checkbox"
                            id="shipping_sameAsBilling"
                          />
                          <label htmlFor="shipping_sameAsBilling">
                            Uguale a indirizzo di fatturazione
                          </label>
                        </CheckboxContainer>
                        {!this.props.sameAsBilling && (
                          <div className="new-shipping-address">
                            <div>
                              {this.props.isCompany === 'true' ? (
                                <Field
                                  name="shipping.name"
                                  component={TextField}
                                  type="text"
                                  label="Ragione sociale"
                                />
                              ) : (
                                <Field
                                  name="shipping.name"
                                  component={TextField}
                                  type="text"
                                  label="Destinatario"
                                />
                              )}
                              <Field
                                name="shipping.address1"
                                component={TextField}
                                type="text"
                                label="Indirizzo e Numero Civico"
                              />
                              <Field
                                name="shipping.address2"
                                component={TextField}
                                type="text"
                                label="Note indirizzo"
                              />
                              {hasSalesAbroad && (
                                <Field
                                  name="shipping.country"
                                  component={SelectField}
                                  label="Nazione"
                                  nullOption={{
                                    value: 'Italia',
                                    label: 'Italia',
                                  }}
                                  options={countries.map(c => ({
                                    value: c.name,
                                    label: c.name,
                                  }))}
                                />
                              )}

                              <div className="row">
                                <div className="col-sm-8">
                                  {hasSalesAbroad && country !== 'Italia' ? (
                                    <Field
                                      name="shipping.city"
                                      id="shipping.city"
                                      component={TextField}
                                      label="Città"
                                    />
                                  ) : (
                                    <Field
                                      name="shipping.city"
                                      id="shipping.city"
                                      component={this.renderSelectCities}
                                      label="Città"
                                    />
                                  )}
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    name="shipping.zipcode"
                                    component={TextField}
                                    type="text"
                                    label="CAP"
                                    normalize={normalizeZipcode}
                                  />
                                </div>
                              </div>
                              <Field
                                name="shipping.phone"
                                component={TextField}
                                type="text"
                                label="Telefono"
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <hr />

                    <Field
                      name="hasAcceptedPrivacyPolicy"
                      component={this.renderPrivacyCheck}
                      type="checkbox"
                    />
                    {!this.props.simpleRegistration && (
                      <Field
                        name="hasSubscribedToNewsletter"
                        component={this.renderMarketingCheck}
                        type="checkbox"
                      />
                    )}

                    <div className="btn-container">
                      <Button type="submit" className="btn btn-primary">
                        Crea account
                      </Button>
                      {!!createUserError && (
                        <div
                          style={{
                            fontSize: 13,
                            color: '#f77878',
                            marginTop: 16,
                          }}
                        >
                          {createUserError}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {
    shipping: {},
    billing: {},
  };

  if (!values.email) {
    errors.email = 'Richiesto';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Indirizzo email non valido';
  }
  if (!values.password && !values.provider) {
    errors.password = 'Richiesto';
  }
  if (!values.confirmPassword && !values.provider) {
    errors.confirmPassword = 'Richiesto';
  } else if (values.confirmPassword !== values.password && !values.provider) {
    errors.confirmPassword = 'Le due password non coincidono';
  }

  if (values.shipping) {
    if (!values.shipping.name) {
      errors.shipping.name = 'Richiesto';
    }
    if (!values.shipping.address1) {
      errors.shipping.address1 = 'Richiesto';
    }
    if (!values.shipping.city) {
      errors.shipping.city = 'Richiesto';
    }
    if (!values.shipping.zipcode) {
      errors.shipping.zipcode = 'Richiesto';
    }
    if (!values.shipping.phone) {
      errors.shipping.phone = 'Richiesto';
    }
  }

  if (values.billing) {
    if (!values.billing.company) {
      errors.billing.company = 'Richiesto';
    }
    if (!values.billing.firstname) {
      errors.billing.firstname = 'Richiesto';
    }
    if (
      !nomeCoerente(values.billing.taxCode, values.billing.firstname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.firstname = 'Nome non coerente con Codice Fiscale';
    }
    if (!values.billing.lastname) {
      errors.billing.lastname = 'Richiesto';
    }
    if (
      !cognomeCoerente(values.billing.taxCode, values.billing.lastname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.lastname = 'Cognome non coerente con Codice Fiscale';
    }
    if (!values.billing.vatNumber) {
      errors.billing.vatNumber = 'Richiesto';
    }
    if (values.billing.isCompany) {
      if (
        !!values.billing.vatNumber &&
        !pIvaCoerente(values.billing.vatNumber).isValid
      ) {
        errors.billing.vatNumber = pIvaCoerente(values.billing.vatNumber).text;
      }
    }
    if (!values.billing.sdiCode && !values.billing.pec) {
      errors.billing.sdiCode = 'Richiesti codice SDI o PEC';
      errors.billing.pec = 'Richiesti codice SDI o PEC';
    }

    if (!values.billing.taxCode) {
      errors.billing.taxCode = 'Richiesto';
    } else if (
      !codiceFiscaleValido(values.billing.taxCode) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.taxCode = 'Codice fiscale non valido';
    }

    if (!values.billing.address1) {
      errors.billing.address1 = 'Richiesto';
    }
    if (!values.billing.city) {
      errors.billing.city = 'Richiesto';
    }
    if (!values.billing.zipcode) {
      errors.billing.zipcode = 'Richiesto';
    }
    if (!values.billing.phone) {
      errors.billing.phone = 'Richiesto';
    }
  }

  if (!values.hasAcceptedPrivacyPolicy) {
    errors.hasAcceptedPrivacyPolicy =
      'È necessario aver preso visione e accettato la privacy policy per procedere alla registrazione';
  }
  return errors;
};

const normalizeTaxCode = value => (value || '').toUpperCase();
const normalizeZipcode = value => (value || '').replace(/[^\d]/g, '');

const asyncValidate = (values, dispatch, props) => {
  const { endpoint, method, headers, body } = api.checkEmailAvailability(
    values.email
  );

  const headersWithStoreId = {
    ...headers,
    storeid: props.storeId,
  };

  return fetch(endpoint, { method, headers: headersWithStoreId, body }).then(
    response => {
      if (response.ok) {
        return response.json().then(data => {
          if (!data.available) {
            throw { email: "L'indirizzo email inserito è già utilizzato" };
          }
          return Promise.resolve(true);
        });
      } else {
        throw {
          email:
            "È avvenuto un errore durante la validazione dell'indirizzo email",
        };
      }
    }
  );
};

Registrazione = reduxForm({
  form: 'registration',
  enableReinitialize: true,
  validate,
  asyncValidate,
  asyncBlurFields: ['email'],
})(Registrazione);

const mapStateToProps = (state, props) => {
  const { name, email, provider, providerId } = props.location.query;

  const selector = formValueSelector('registration');

  return {
    cart: state.cart,
    countries: state.countries.data,
    storeId: state.store.data.storeId,
    hasFacebookLogin: state.store.data.features.hasFacebookLogin,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    hasSalesAbroad: state.store.data.features.hasSalesAbroad,
    user: state.user,
    createUserError: state.user.error,
    loading: state.user.loading,
    authenticated: state.user.authenticated,
    billingDefault: selector(state, 'billing.useDefault'),
    sameAsBilling: selector(state, 'shipping.sameAsBilling'),
    shippingDefault: selector(state, 'shipping.useDefault'),
    isCompany: selector(state, 'billing.isCompany'),
    country: selector(state, 'shipping.country'),
    isInvoiceRequested: selector(state, 'isInvoiceRequested'),
    initialValues: {
      email,
      provider,
      providerId,
      billing: {
        isCompany: state.store.data.funzionalita.onlyCompanySignUp
          ? 'true'
          : 'false',
        firstname: name && name.split(' ')[0],
        lastname: name && name.split(' ')[1],
      },
      shipping: {
        sameAsBilling: state.store.data.funzionalita.simpleRegistration
          ? false
          : true,
        name,
        country: 'Italia',
      },
      hasAcceptedPrivacyPolicy: false,
      hasSubscribedToNewsletter: false,
    },
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    onlyCompanySignUp: state.store.data.funzionalita.onlyCompanySignUp,
    simpleRegistration: state.store.data.funzionalita.simpleRegistration,
    iubendaApiKey: state.store.data.integrazioni.iubenda.apiKey,
    privacy: state.store.data.funzionalita.privacy,
  };
};

export default withRouter(
  connect(mapStateToProps, { createUser, loadCities, loadCountries })(
    Registrazione
  )
);
